//------------------
// is empty
//------------------
export default function isEmpty(value) {
  return (
    // null or undefined
    value == undefined ||
    value === undefined ||
    value == 'undefined' ||
    value == null ||
    // has length and it's zero
    (Object.prototype.hasOwnProperty.call(value, 'length') && value.length === 0) ||
    // is an Object and has no keys
    (value.constructor === Object && Object.keys(value).length === 0)
  )
}
